import {
  ClosestVenuesInShapeByCategoryRequest,
  ClosestVenuesInShapeByCategoryResponse,
} from 'src/common-services/types/foursquare-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class FoursquareClient extends BaseClient {
  async getClosestVenuesInShapeByCategory(
    request: ClosestVenuesInShapeByCategoryRequest
  ): Promise<ClosestVenuesInShapeByCategoryResponse> {
    return await this.call<ClosestVenuesInShapeByCategoryResponse>(
      `/footfall/report/${encodeURIComponent(request.category)}`,
      'POST',
      {
        data: {
          geo: request.geo,
          point: request.point,
        },
        params: {
          limit: request.limit,
        },
      }
    )
  }
}
